import { SERVER_URL } from "./config";

const groupNames = ["group-1", "group-2","group-3"];

const groupInfo = {
    "group-1": [
        {
            label: "Station Name",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "name",
            type: "text",
            placeHolder: "",
            url: SERVER_URL + "/branch/",
            suggestionKeyword: "name",
            apiConfigKey: "getCitySuggestions",
            suggestionKeywordForFetchApiArgs: "name",
            suggestionChooseQueryKeyword: "branch_id",
            suggestionKeywordExtra: "pin_code",
            backendOnClickName: "pan_no",
            keyboardNavigationMap: {
                Enter: "start_no",
            },
            toValidate: true,
            apiCallRequiredOnGetValue: true,
            suggestionSchema: {
                name: "name",
                branch_id: "branch_id",
            },
            // idClearanceNeeded: "branch_id",
        },
        {
            label: "Start No",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "start_no",
            type: "text",
            placeHolder: "",
            toValidate: false,
            regExpValidation: "^(?:[0-9]+d*|d)$",
            keyboardNavigationMap: {
              Enter: "end_no",
            },
          },
        {
            label: "End No",
            className: "form-row",
            labelClassName: "form-label",
            inputClassName: "form-input",
            name: "end_no",
            type: "text",
            placeHolder: "",
            toValidate: false,
            regExpValidation: "^(?:[0-9]+d*|d)$",
            keyboardNavigationMap: {
              Enter: "save_button",
            },
          },
    ],
};

const dataObject = {
    branch_id: "",
    name: "",
    start_no: "",
    end_no: "",
};

function validate(values) {
    let errors = {};

    return errors;
}

const popupInfo = {
  success_header: "Success",
  success_title: "LR Master saved successfully.",
  field_label_success: "LR Master No:",
  field_name_success: "start_no", // or any field you want to display

  error_header: "Error",
  error_title: "Unable to save LR Master.",
  field_label_error: "Reason:",
};

export {
    groupInfo,
    dataObject,
    validate,
    popupInfo,
};